<template>
  <div>
    <v-app-bar
      app
      :color="playlist.default_color ? playlist.default_color : '#2196F3'"
      dark
    >
      <v-app-bar-nav-icon
        aria-label="Toggle table of contents"
        @click.stop="drawer = !drawer"
        v-show="!editMode"
      />
      <v-toolbar-title>{{ playlist.name }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <div v-if="$vuetify.breakpoint.mdAndUp || user.userType === 'student'">
        <div
          id="add-new-bulb"
          class="dropdown-menu-button"
          v-if="(
            canEditPlaylist
            && user.userType === 'teacher'
            && editMode
          )"
        >
          <v-btn
            id="createNewBulbButton"
            color="white"
            class="mr-2 primary-dropdown-menu-button"
            :loading="isUpdating"
            @click="createNewPlaylistBulb()"
            :style="finishExitButtonCss"
          >
            Create new Bulb
          </v-btn>
          <v-menu
            offset-y
            contained
            nudge-left="174%"
            max-width="100%"
            min-width="100%"
            attach="#add-new-bulb"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                color="white"
                class="secondary-dropdown-menu-button"
              >
                <v-icon
                  :color="playlist.default_color ? playlist.default_color : '#2196F3'">
                  keyboard_arrow_down
                </v-icon>
              </v-btn>
            </template>
            <div class="add-more-menu">
              <v-list density="compact">
                <v-list-item @click="isCreateLmbModalOpen = true">
                  <v-list-item-title>Create Learner Made Bulb</v-list-item-title>
                </v-list-item>
              </v-list>
            </div>
          </v-menu>
        </div>
        <v-btn
          v-if="(
            canEditPlaylist
            || (
              user.userType === 'student'
              && !hasHidePlaylistSaveAndExitButtonFeature
            )
          )"
          id="finishExitButton"
          color="white"
          class="mr-2"
          :loading="isUpdating"
          @click="saveAndExit()"
          :style="finishExitButtonCss"
        >
          Save & Exit
        </v-btn>
        <v-menu offset-y v-if="user.userType === 'teacher' && canEditPlaylist && editMode && playlist.sections.length > 0">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              id="monitorButton"
              outlined
              class="mr-2"
              v-bind="attrs"
              v-on="on"
            >
              Monitor
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(section, index) in playlist.sections"
              :key="index"
              @click="launchDashMonitor(section.id)"
            >
              <v-list-item-title>{{ section.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          id="assignPlaylistButton"
          v-if="(
            !isFlipEdPlaylist
            && user.userType === 'teacher'
            && canEditPlaylist
            && editMode
          )"
          class="mr-2"
          outlined
          color="white"
          @click="launchDashAssign(playlist.id)"
          >
          Assign
        </v-btn>
      </div>
      <v-menu
        v-else
        bottom
        right
        offset-y
        offset-x>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-if="(
              canEditPlaylist
              && user.userType === 'teacher'
            )">
            <v-btn
              id="createNewBulbButton"
              :color="playlist.default_color"
              dark
              class="mr-2"
              @click="createNewPlaylistBulb()"
            >
              Create new Bulb
            </v-btn>
          </v-list-item>
          <v-list-item
            v-if="(
              canEditPlaylist
              && user.userType === 'teacher'
            )">
            <v-btn
              :color="playlist.default_color"
              dark
              class="mr-2"
              @click="isCreateLmbModalOpen = true"
            >
              Create Learner Made Bulb
            </v-btn>
          </v-list-item>
          <v-list-item
            v-if="(
              canEditPlaylist
              || user.userType === 'student'
            )">
            <v-btn
              id="finishExitButton"
              :color="playlist.default_color"
              dark
              class="mr-2"
              @click="saveAndExit()"
            >
              Save & Exit
            </v-btn>
          </v-list-item>
          <v-list-item
            v-if="(
              user.userType === 'teacher'
              && canEditPlaylist
              && editMode
              && playlist.sections.length > 0
            )">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  id="monitorButton"
                  outlined
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                  :color="playlist.default_color"
                >
                  Monitor
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(section, index) in playlist.sections"
                  :key="index"
                  @click="launchDashMonitor(section.id)"
                >
                  <v-list-item-title>{{ section.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item>
          <v-list-item
            v-if="(
              !isFlipEdPlaylist
              && user.userType === 'teacher'
              && canEditPlaylist
              && editMode
            )">
           <v-btn
              id="assignPlaylistButton"
              class="mr-2"
              outlined
              :color="playlist.default_color"
              @click="launchDashAssign(playlist.id)"
              >
                Assign
            </v-btn>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        id="fullscreenButton"
        v-if="(
          !isMobileIOS
          && !isBlackboardPlaylist
        )"
        icon
        class="mr-1"
        @click="handleFullscreen"
        aria-label="Make playlist fullscreen">
        <v-icon v-if="isFullscreen">mdi-fullscreen-exit</v-icon>
        <v-icon v-else>mdi-fullscreen</v-icon>
      </v-btn>
      <v-switch
        v-if="isMigratedTeacher"
        :value="0"
        label="Preview Mode"
        hide-details
        disabled
      ></v-switch>
      <v-switch
        v-else-if="isTeacher"
        dark
        v-model="editMode"
        :label="currentMode"
        hide-details
      ></v-switch>
    </v-app-bar>

    <v-navigation-drawer
      role="navigation"
      aria-label="playlist contents"
      v-model="drawer"
      v-show="!editMode"
      ref="playlistWrapperVNavigationDrawer"
      app
      :disable-resize-watcher="true"
    >
      <v-list dense>
        <v-list-item>
          <h2 class="playlist-headline font-weight-light mt-5" id="tableOfContents">Table of Contents</h2>
        </v-list-item>
        <ModuleTOC v-for="module in playlist.modules" :key="module.id" :module="module" :moduleId="module.id"/>
      </v-list>
      <v-container v-if="hasPlaylistCertificateAccess" class="d-flex justify-center flex-column">
        <v-btn
          :disabled="!canAccessCertificate"
          :color="playlist.default_color ? playlist.default_color : '#2196F3'"
          :to="isCompleted ? { name: 'Course Certificate', params: { certificateHash: encodedId, courseHash }} : null"
          class="white--text"
          target="_blank">
          Print Certificate
        </v-btn>
      </v-container>
      <BadgeAssertionModal v-if="showBadgeEarned" :badgeAdded="badgeAdded" :badgeAssertion="badgeAssertion"></BadgeAssertionModal>
    </v-navigation-drawer>

    <v-main id="mainContent" class="pt-1">
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
          v-if="!editMode">
          <v-col class="text-center">
            <h1
              v-if="downloadResourceURL"
              class="playlist-headline">Linked Resource:
            </h1>
            <h1
              :class="moduleItemTitleClass">
              {{ activeModuleItemName }}
              <v-btn
                v-if="activeResourceLinkURL && activeResourceLinkURL.name"
                icon
                @click="handleFullscreenLinkImage"
                large
                aria-label="Make link fullscreen">
                <v-icon>mdi-fullscreen</v-icon>
              </v-btn>
            </h1>
            <!-- Plain link on mobile: the Adobe viewer's download fails in app WebViews (e.g. Canvas Android) -->
            <v-btn
              v-if="isMobile && activeResourceLinkIsPDF"
              :href="activeResourceLinkURL"
              :color="playlist.default_color"
              target="_blank"
              dark
              small
              @click="logPdfDownload">
              <v-icon left>mdi-download</v-icon>
              Download PDF
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col align="center">
            <div style="position: relative" v-if="!editMode">
              <v-responsive
                :aspect-ratio="16/9"
                :style="$vuetify.breakpoint.xsOnly ? { height: '600px' } : { maxWidth: '85%', height: '100%' }">
                <iframe
                  v-if="activePlaylistVideo.bulbId"
                  id="playerIframe"
                  :src="activePlaylistVideoURL"
                  :key="activePlaylistVideoURLKey"
                  class="responsive-iframe"
                  allow="autoplay *;">
                </iframe>
                <iframe
                  v-else-if="(
                    activeLMB.bulbId
                    && user.userType === 'student'
                  )"
                  id="lmbIframe"
                  :src="activeLMBURL"
                  :key="activeLMBKey"
                  class="responsive-iframe"
                  allow="autoplay *;">
                </iframe>
                <v-img
                  id="teacherLMBImg"
                  v-else-if="(
                    activeLMB.bulbId
                    && user.userType === 'teacher'
                  )"
                  :src="activeLMBURL">
                </v-img>
                <v-img
                  v-else-if="(
                    activeResourceLinkURL
                    && !_.isEmpty(activeResourceLinkURL)
                    && !activeResourceLinkIsPDF
                    && !_.get(activeModuleItem, 'link.url')
                  )"
                  id="moduleItemImage"
                  :src="resourceURL"
                  :alt="activeModuleItemName"
                  :aspect-ratio="16/9"
                  class="responsive-iframe"
                  ref='linkImage'
                  allowFullscreen>
                </v-img>
                <iframe
                  v-else-if="(
                    activeResourceLinkURL
                    && !_.isEmpty(activeResourceLinkURL)
                    && !activeResourceLinkIsPDF
                    && _.get(activeModuleItem, 'link.url')
                  )"
                  id="linkIframe"
                  :src="resourceURL"
                  class="responsive-iframe"
                  ref='linkFrame'
                  allowFullscreen
                >
                </iframe>
                <!-- PDF view: -->
                <div
                  v-else-if="(
                    activeResourceLinkURL
                    && !_.isEmpty(activeResourceLinkURL)
                    && activeResourceLinkIsPDF
                  )"
                  id="pdf-view"
                >
                </div>
                <!-- Text Item Module View: -->
                <div
                  v-else-if="(
                    activeTextElement
                    && activeTextElement.body
                  )"
                  v-html="activeTextElement.body"
                >
                </div>
                <div v-else-if="downloadResourceURL">
                  <p>There is a linked resource for this playlist.  Click the button below to download it.</p>
                  <v-btn
                    :color="playlist.default_color"
                    :href="isMobile ? downloadResourceURL : undefined"
                    :target="isMobile ? '_blank' : undefined"
                    dark
                    @click="handleDownloadAttachment">
                    Download Attachment
                  </v-btn>
                </div>
                <v-alert
                  v-else-if="(
                    noValidModuleItems
                    || allBulbsDeleted
                  )"
                  type="info"
                  prominent
                  max-width="80%"
                >
                    <v-row align="center">
                      <v-col v-if="user.userType === 'teacher'" class="grow">No content currently in Playlist.  If you are the owner, add content from the Playlist Designer.</v-col>
                      <v-col v-else class="grow">The Playlist owner hasn't added any content to this Playlist.  Please check with your instructor.</v-col>
                      <v-col class="shrink">
                        <v-btn
                        small
                        outlined
                        v-if="user.teacherContainerRole === 1 && !user.migrated"
                        @click="togglePlaylistDesigner">Playlist Designer</v-btn>
                      </v-col>
                    </v-row>
                </v-alert>
              </v-responsive>
            </div>
            <PlaylistDesigner v-else-if="canEditPlaylist" :key="playlistDesignerKey"></PlaylistDesigner>
            <PlaylistCopy v-else></PlaylistCopy>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
/* global dataLayer */

// Core:
import {
  mapState,
  mapGetters,
  mapActions,
  mapMutations,
} from 'vuex';
import { mapFields } from 'vuex-map-fields';

// Libraries / Plugins:
import _ from 'lodash';
import screenfull from 'screenfull';

// Custom Helpers:
import { waitForElementToDisplay } from '@utilities';

// Global Mixins:
import PdfViewer from '@mixins/PdfViewer/PdfViewer';

// Custom Components:
import BadgeAssertionModal from './BadgeAssertionModal.vue';
import ModuleTOC from './ModuleTOC.vue';
import PlaylistCopy from './PlaylistCopy.vue';
import PlaylistDesigner from './PlaylistDesigner.vue';

export default {
  components: {
    BadgeAssertionModal,
    ModuleTOC,
    PlaylistCopy,
    PlaylistDesigner,
  },
  props: {
    source: String,
  },
  mixins: [PdfViewer],
  data: () => ({
    activeLMBKey: 1,
    activePDFPage: 0,
    isPreviewingPDF: false,
    activePlaylistVideoURLKey: 1,
    badgeAssertion: null,
    baseURL: null,
    drawer: false,
    encodedId: null,
    isFullscreen: false,
    pdfAPIReady: false,
  }),
  watch: {
    activeResourceLinkURL(n) {
      if (n) this.previewPDF();
    },
    adobeViewerSDKScriptInjected(newValue) {
      if (newValue) this.previewPDF();
    },
    editMode(n, o) {
      if (n) this.drawer = false;
      else this.drawer = true;
      if (!n && o) {
        this.getPlaylist({ playlistId: this.playlist.id });
        this.previewPDF();
      }
    },
    isCompleted(newValue) {
      if (
        newValue
        && this.badgrEnabled
      ) {
        this.assertBadgrBadge();
      } else if (
        newValue
        && this.credlyEnabled
      ) this.issueCredlyBadge();
      if (
        newValue
        && this.isLti
        && this.lmsEnabledGrading === 1
      ) {
        this.syncLTI();
      }
      if (
        newValue
        && _.get(this.section, 'key[0]', '') === 'g'
        && this.section?.playlistSection?.courseWorkId
        && this.user.userType === 'student'
        && this.playlistAttempt?.studentSubmissionId
      ) {
        this.syncGoogleGrades();
      }
      if (newValue) {
        this.sendPlaylistPostMessage('completion');
      }
    },
    onLastPDFPage(n) {
      if (n) this.setPDFComplete(true);
    },
  },
  computed: {
    ...mapState([
      'activeLMB',
      'activePlaylistVideo',
      'activeResourceLinkURL',
      'activeTextElement',
      'allBulbsInPlaylist',
      'courseHash',
      'downloadResourceURL',
      'isCompleted',
      'mobileDetect',
      'isLti',
      'isUpdating',
      'lastPDFPage',
      'PDFComplete',
      'playlist',
      'playlistAttempt',
      'playlistDesignerKey',
      'playlistHasLMBs',
      'user',
      'userToken',
      'school',
      'sectionId',
      'studentSubmissionId',
    ]),
    ...mapGetters([
      'activeLMBURL',
      'activePlaylistVideoURL',
      'hasPlaylistCertificateAccess',
      'hasHidePlaylistSaveAndExitButtonFeature',
      'isMobile',
      'isMobileIOS',
      'lmsConsumerVersion',
      'lmsEnabledGrading',
      'queryParams',
    ]),
    ...mapFields([
      'editMode',
      'isCreateLmbModalOpen',
    ]),
    activeModuleItem() {
      const activeItemId = parseInt(this.$route.params.itemId, 10);
      return _.find(this.playlist.allModuleItems, { itemId: activeItemId });
    },
    activeModuleItemName() {
      if (['text'].includes(this.activeModuleItem?.type)) return this.activeModuleItem?.text.title || '';
      return this.activeModuleItem?.name || this.activeModuleItem?.bulb?.name || '';
    },
    activeResourceLinkIsPDF() {
      if (typeof this.activeResourceLinkURL === 'string') return _.get(this, 'activeResourceLinkURL', []).includes('.pdf');
      return false;
    },
    allBulbsDeleted() {
      if (!this.allBulbsInPlaylist?.length) return false;
      return !_.find(this.allBulbsInPlaylist, { deleted: false });
    },
    badgeAdded() {
      if (this.badgrEnabled) return _.get(this.playlist, 'badge.badgr.badge');
      return _.get(this.playlist, 'badge.credly.badge');
    },
    badgrEnabled() {
      return _.get(this.playlist, 'badge.badgr.enabled', false);
    },
    canAccessCertificate() {
      return (
        !this.isUpdating
        && this.isCompleted
        && this.lmbsGraded
      );
    },
    canEditPlaylist() {
      return [1, 2, 3].includes(this.user.teacherContainerRole);
    },
    credlyEnabled() {
      return _.get(this.playlist, 'badge.credly.enabled', false);
    },
    currentMode() {
      if (this.editMode) return 'Edit Mode';
      return 'Preview Mode';
    },
    finishExitButtonCss() {
      return {
        color: this.playlist.default_color,
      };
    },
    /*
    * Blackboard doesn't allow us to go fullscreen - so we hide the button when it is a Blackboard playlist
    */
    isBlackboardPlaylist() {
      return (
        this.isLti
        && this?.lmsConsumerVersion?.includes('Blackboard')
      );
    },
    isFlipEdPlaylist() {
      return (
        _.get(this.playlist, 'config.sku')
        && _.get(this.playlist, 'sections', []).length === 1
      );
    },
    isTeacher() {
      return this.user.userType === 'teacher' && _.get(this.user, 'teacherContainerRole') !== 4;
    },
    isMigratedTeacher() {
      return (
        this.isTeacher
        && !!this.user.migrated
      );
    },
    lmbsGraded() {
      if (
        !this.playlistHasLMBs
        || !_.get(this, 'playlist.config.certificateLMBAccess', false)
      ) return true;
      for (const moduleItem of this.playlist.allModuleItems) {
        if (
          moduleItem.type === 'bulb'
          && moduleItem?.bulbAttempt?.complete
          && moduleItem.bulb.lmbId
          && moduleItem.bulbAttempt?.pointsAvailable
        ) {
          if (_.isNull(moduleItem.bulbAttempt.pointsEarned)) return false;
        }
      }
      return true;
    },
    moduleItemTitleClass() {
      return this.downloadResourceURL ? 'playlist-module-item-title' : 'playlist-module-item-headline';
    },
    noValidModuleItems() {
      return this.$route.params.itemId === '0';
    },
    onLastPDFPage() {
      return this.activePDFPage === this.lastPDFPage;
    },
    resourceURL() {
      if (_.has(this.activeResourceLinkURL, 'link')) return _.get(this.activeResourceLinkURL, 'link.url');
      return this.activeResourceLinkURL;
    },
    section() {
      return _.find(this.playlist.sections, { id: this.sectionId }) || null;
    },
    showBadgeEarned() {
      return (
        this.isCompleted
        && !_.isEmpty(this.badgeAssertion)
        && (
          this.badgrEnabled
          || this.credlyEnabled
        )
      );
    },
  },
  methods: {
    ...mapActions([
      'encodeUserId',
      'generateBadge',
      'getPlaylist',
      'getSimplifiedPlaylist',
      'launchDashAssign',
      'launchDashMonitor',
      'markModuleItemAttemptComplete',
      'playlistPDRedirect',
      'syncLTI',
    ]),
    ...mapMutations([
      'setAdobePDFError',
      'setIsUpdating',
      'setLastPDFPage',
      'setNextItemTimeoutToast',
      'setPDFComplete',
      'toggleSnackbar',
    ]),
    async assertBadgrBadge() {
      try {
        this.setIsUpdating(true);
        const { data: badgeAssertion } = await this.$api.badgr.assert({
          playlistId: this.playlist.id,
          userData: {
            email: this.user.email,
            firstName: this.user.firstName,
            schoolId: this.playlist.school.id,
          },
        });
        this.badgeAssertion = badgeAssertion;
        this.toggleSnackbar({
          text: 'Badge earned!',
          color: 'success',
          timeout: 2500,
        });
      } catch (e) {
        this.toggleSnackbar({
          text: 'Error generating badge.',
          color: 'error',
          timeout: 2500,
        });
      } finally {
        this.setIsUpdating(false);
      }
    },
    async getCredlyAssertion() {
      try {
        const { data: badgeAssertion } = await this.$api.credly.assertion({
          badgeTemplateId: _.get(this.playlist, 'badge.credly.badge.id'),
          playlistId: this.playlist.id,
          schoolId: this.playlist.school.id,
        });
        this.badgeAssertion = badgeAssertion;
      } catch(e) {
        this.toggleSnackbar({
          text: 'Error getting Credly assertion.',
          color: 'error',
          timeout: 2500,
        });
      }
    },
    handleDownloadAttachment() {
      if (this.user.userType !== 'teacher') this.popNextItemToast(0);
      // On mobile the button's href opens the file; window.open is ignored by app WebViews
      if (!this.isMobile) window.open(this.downloadResourceURL);
      const gaDownloadAttachmentAction = `Playlist: attachment downloaded -- schoolId: ${this.user.schoolId}, playlistId: ${this.playlist.id}, fileURL: ${this.downloadResourceURL}`;
      dataLayer.manualLog(gaDownloadAttachmentAction, 'playlistAttachmentDownload');
    },
    logPdfDownload() {
      const documentDownloadEvent = `Playlist: pdf attachment downloaded -- schoolId: ${this.user.schoolId}, playlistId: ${this.playlist.id}, fileName: ${this.activeModuleItemName}`;
      dataLayer.manualLog(documentDownloadEvent, 'playlistPdfAttachmentDownload');
    },
    handleFullscreen() {
      if (screenfull.isFullscreen) screenfull.exit();
      else screenfull.request(this.$refs.mainPlaylist);
    },
    handleFullscreenLinkImage() {
      screenfull.request(this.$refs.linkImage);
    },
    async issueCredlyBadge() {
      try {
        this.setIsUpdating(true);
        const { data: badgeAssertion } = await this.$api.credly.issue({
          badgeTemplateId: _.get(this.playlist, 'badge.credly.badge.id'),
          email: this.user.email,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          schoolId: this.playlist.school.id,
        });
        this.badgeAssertion = badgeAssertion;
        this.toggleSnackbar({
          text: 'Badge earned!',
          color: 'success',
          timeout: 2500,
        });
      } catch (e) {
        this.toggleSnackbar({
          text: 'Error generating badge.',
          color: 'error',
          timeout: 2500,
        });
      } finally {
        this.setIsUpdating(false);
      }
    },
    popNextItemToast(timeout = 5000) {
      if (_.get(this.user, 'userType', '') === 'teacher') return;
      const toastTimeout = setTimeout(() => {
        const lastModuleItemIndex = this.playlist.allModuleItems.length - 1;
        const currentModuleItemIndex = _.findIndex(this.playlist.allModuleItems, { itemId: this.activeModuleItem.id });
        if (currentModuleItemIndex === lastModuleItemIndex) {
          this.snackbarAction = false;
        } else {
          this.snackbarAction = true;
        }
        this.markModuleItemAttemptComplete(this.activeModuleItem.id);
        this.toggleSnackbar({
          text: 'Item completed!',
          color: 'success',
          action: this.snackbarAction,
          timeout: this.snackbarAction ? -1 : 5000,
        });
      }, timeout);
      this.setNextItemTimeoutToast(toastTimeout);
    },
    async previewPDF() {
      if (!this.activeResourceLinkIsPDF || this.isPreviewingPDF) return;
      this.isPreviewingPDF = true;
      try {
        await this.$nextTick();
        const pdfDiv = await waitForElementToDisplay('#pdf-view');
        if (
          pdfDiv
          && this.adobeViewerSDKScriptInjected
        ) {
          this.createAdobeViewerInstance();
          this.previewFile({
            resourceLocationUrl: this?.activeResourceLinkURL,
            resourceIdentifier: this?.activeModuleItem?.name,
            showDownloadPDF: !this.isMobile,
          });
          await this.$nextTick();
          this.activePDFPage = 1;
          this.fetchPdfMetadata().then((numPages) => {
            this.setLastPDFPage(numPages);
          }).catch((error) => {
            this.setPDFComplete(true);
            console.error(error); // eslint-disable-line
          });
          /**
           * Invoking this, will allow us to always receive the *current* page the user is on.
           */
          this.initializePdfViewerEventListeners({
            vm: this,
          });
        }
      } finally {
        this.isPreviewingPDF = false;
      }
    },
    async saveAndExit() {
      this.sendPlaylistPostMessage('finish-and-exit');
      if (
        this.isLti
        || (
          _.get(this.playlist, 'config.sku', false)
          && !this.isTeacher
        )
      ) {
        this.$enablePlaypositErrorScreen({
          vertical: true,
          active_color: '#2196F3',
          base_color: '#0d47a1',
          inactive_color: '#757575',
          title: 'Playlist Saved',
          subtitle: this.isLti ? 'Please close this tab and return to your LMS' : 'You can return to your course',
          code: '',
          text: '',
          icon: 'check_circle',
          buttons: [],
        });
        this.activePlaylistVideoURLKey += 1;
        this.activeLMBKey += 1;
      } else if (
        this.isTeacher
        && _.get(this.user, 'school.config.permissions', []).includes('hasPlaylistAccess')
      ) {
        window.location.replace(`${this.baseURL}dash/instructor/Playlists/Playlists?page=1&per_page=20&search=&sort=&section_id=&bulb_id=&interaction_id=&interaction_type=&student_id=&folder_id=&subfolder_id=&lms_class=false&lms_launch=false&lmb_bulb=&lmb_section=&playlistGradebook&token=${this.userToken}`);
      } else if (this.playlist.isPDPlaylist) {
        try {
          this.setIsUpdating(true);
          const { data: teacherToken } = await this.$api.playlist.PDRedirect();
          window.location.replace(`${this.baseURL}dash/?token=${teacherToken}&view=PD`);
        } catch(e) {
          window.location.replace(`${this.baseURL}dash/?token=${this.userToken}`);
        }
      } else window.location.replace(`${this.baseURL}dash/?token=${this.userToken}`);
    },
    async sendPlaylistPostMessage(type) {
      try {
        const messageType = type === 'completion' ? 'playposit_playlist__completion' : 'playposit_playlist__exit';
        // eslint-disable-next-line
        const parentFrame = window.parent != null ? window.parent : (window.top != null ? window.top : null);
        if (parentFrame != null) {
          const postObject = {
            type: messageType,
            student_id: this.user.id,
            playlist_id: this.playlist.id,
            event: type,
          };
          parentFrame.postMessage(JSON.stringify(postObject), '*');
        }
      } catch (e) {
        dataLayer.errorLog(
          {
            msg: `Unable to send post message. err: ${JSON.stringify(e)}`,
            location: 'PlaylistWrapper: sendPlaylistPostMessage',
          },
        );
      }
    },
    async syncGoogleGrades() {
      const { data: response } = await this.$api.googleClassroom.syncGrades({
        playlistId: this.playlist.id,
        courseId: _.get(this.section, 'key', '').substring(1),
        courseWorkId: this.section?.playlistSection?.courseWorkId,
        sectionId: this.sectionId,
        studentSubmissionId: this.studentSubmissionId,
      });
      if (response.synced) {
        this.toggleSnackbar({
          text: 'Grades synced to Google Classroom.',
          color: 'success',
          timeout: 5000,
        });
      } else {
        this.toggleSnackbar({
          text: 'Grade sync error.',
          color: 'warning',
          timeout: 5000,
        });
      }
    },
    createNewPlaylistBulb() {
      const windowRef = window.open(
        `${this.baseURL}designer/?bulb_id=new&token=${this.userToken}&lms_launch=${this.isLti}&playlist_launch=true`,
        '_blank',
      );
      const windowRefInterval = setInterval(() => {
        if (windowRef?.closed) {
          clearInterval(windowRefInterval);
          this.toggleSnackbar({
            text: 'Bulb successfully created! You can now add it to a module.',
            color: 'success',
          });
        }
      }, 1000);
    },
    async setEncodedUserId() {
      const encodedData = await this.encodeUserId(this.user.id);
      this.encodedId = encodedData.data;
    },
    setupScreenfullEvents() {
      if (screenfull.isEnabled) {
        screenfull.on('change', () => {
          this.isFullscreen = screenfull.isFullscreen;
        });
      }
    },
    togglePlaylistDesigner() {
      this.editMode = true;
    },
  },
  async mounted() {
    window.PP.PlaylistWrapper = {
      vm: this,
    };
    // If Preview param present - default to Playlist Player
    if (
      this.queryParams.has('preview')
      || this.user.userType === 'student'
      || this.isMigratedTeacher
    ) {
      this.drawer = true;
      this.editMode = false;
      this.previewPDF();
    } else if (this.isTeacher) { // If teacher accessing Playlist - default to Designer
      this.drawer = false;
      this.editMode = true;
    }
    if (this.user.userType === 'student') {
      await this.setEncodedUserId();
      await this.getSimplifiedPlaylist({
        playlistId: this.playlist.id,
        encodedId: this.encodedId,
      });
    }
    this.baseURL = this.$getServerUrl();
    if (
      this.badgrEnabled
      && this.user.userType === 'student'
      && this.isCompleted
    ) {
      const { data: assertion } = await this.$api.badgr.getAssertion({
        badgeEntityId: _.get(this.playlist, 'badge.badgr.badge.entityId'),
        schoolId: _.get(this.playlist, 'school.id', null),
      });
      this.badgeAssertion = assertion;
    }
    // If Playlist is complete and has a credly badge - fetch the assertion
    if (
      this.credlyEnabled
      && this.user.userType === 'student'
      && this.isCompleted
    ) {
      await this.getCredlyAssertion();
    }
    if (this.allBulbsDeleted) {
      const path = `/course/${this.courseHash}/module/0/item/0`;
      if (this.$route.path !== path) {
        this.$router.push({
          name: 'Course Home',
          params: { courseHash: this.courseHash, moduleId: 0, itemId: 0 },
        });
      }
    }
    this.setupScreenfullEvents();
  },
};
</script>

<style lang="scss">
  .certificateLink {
    text-decoration: none;
    padding: 6px 16px 6px 16px;
  }
  .responsive-iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }
  #teacherLMBImg {
    width: 70%;
    height: 70%;
  }
  /* used to stop Vuetify from adding unnecessary padding when sidebar opens */
  #mainContent {
    padding: 0 !important;
    ul, ol {
      list-style-position: inside;
    }
  }
  #finishExitButton .v-btn__content,
  #createNewBulbButton .v-btn__content {
    color: var(--text-color);
  }

  .playlist-module-item-title {
    font-size: 1.25rem !important;
    font-weight: 500;
    line-height: 2rem;
    letter-spacing: 0.0125em !important;
  }

  .playlist-module-item-headline {
    font-size: 1.5rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
  }
  .playlist-module-item-title {
    font-size: 1.25rem !important;
    font-weight: 500;
    line-height: 2rem;
    letter-spacing: 0.0125em !important;
  }
  .playlist-module-item-headline {
    font-size: 1.5rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
  }
  .dropdown-menu-button {
    position: relative;
    display: inline-flex;
    margin-right: 8px;

    .primary-dropdown-menu-button {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      margin-right: 0px !important;
    }

    .secondary-dropdown-menu-button {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      min-width: 48px !important;
      padding: 0px 8px !important;
    }
  }
</style>
